import { Outlet, Route } from '@tanstack/router'

import { profileRoute } from '..'

export const affiliateRoute = new Route({
  getParentRoute: () => profileRoute,
  path: 'affiliate',
  component: Outlet,
})
